module.exports = __webpack_public_path__ + "components/flag/static/square/ua-91511b0a6e6b13d8e39b3601b74d0d7a.svg";